/**
 * Create accessorials GraphQL operation
 */

import { resolveExecutor, type GqlExecutor } from '@hopdrive/sdk-core'
import {
  CreateAccessorialsDocument,
  type CreateAccessorialsMutation,
} from '@gql/schema'
import type { Accessorial } from '../../../types/accessorial.js'

/**
 * Create one or more new accessorials in the database
 *
 * @param accessorials - Array of accessorial objects to insert
 * @param executor - Optional GraphQL executor
 * @returns Number of rows affected
 *
 * @example
 * ```typescript
 * const result = await createAccessorials([
 *   {
 *     move_id: 12345,
 *     code: 'delay',
 *     status: 'approved',
 *     cost: 0,
 *     ar_amount: 18.15,
 *     ap_amount: 9.35,
 *     notes: 'Driver delay at pickup location'
 *   }
 * ])
 * ```
 */
export async function createAccessorials(
  accessorials: Accessorial[],
  executor?: GqlExecutor
): Promise<number> {
  const gqlExecutor = resolveExecutor(executor)

  const result = await gqlExecutor.mutate<CreateAccessorialsMutation>(
    CreateAccessorialsDocument,
    { objectArray: accessorials }
  )

  return result.insert_accessorials?.affected_rows ?? 0
}
